<template>
  <el-dialog
    :visible="visible"
    width="40%"
    @close="cancel"
    destroy-on-close
    title="编辑管理员"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submit"
      />
  </el-dialog>
</template>

<script>
import { ManagerService } from '../../service/manager.service';
  export default {
    name: 'managerForm',
    data() {
      return {
        visible: false,
        rules: {
          username: [{ required: true, message: '请填写管理员姓名'}],
          pwd: [{ required: true, message: '请填写密码'}],
        },
        formFields: [
          { type: 'input', key: 'username', label: '管理员姓名', span: 24 },
          { type: 'password', key: 'pwd', label: '密码', span: 24 },
          { type: 'input', key: 'mobile', label: '手机号', span: 24 },
        ],
        defaultValues: {
        },
      }
    },
    methods: {
      open(data) {
        this.defaultValues = data
        this.visible = true;
      },
      cancel() {
        this.visible = false;
      },
      submit(data) {
        this.defaultValues.username = data.username
        this.defaultValues.pwd = data.pwd
        ManagerService.saveManager(this.defaultValues).then(res=>{
          this.$emit('sucess')
          this.cancel();
        })
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>